<wm-datatable
  [useMap]="UseMap"
  [loading]="loading"
  [rows]="applications"
  [columns]="columns"
  [count]="recordCount"
  [offset]="page - 1"
  [limit]="pageSize"
  (mapDataRequested)="onMapDataRequested($event)"
  popupTemplateTitle="Application ID: {applicationNumber}"
  popupTemplateContent="Type: {permitType}&lt;br>Description: {description}&lt;br>Applicant: {applicantsName}&lt;br>Created: {dateCreated}&lt;br>Status: {status}&lt;br>"
  [popupActions]="mapPopupActions"
  [params]="filterCriteria"
  (tabChange)="requestData()"
  [id]="id"
  [bulkActions]="bulkActions"
  [getId]="getId"
  simpleSearchTitle="Search for applications"
  [unpermissibleCount]="unpermissibleCount"
  (settingsChanged)="handleSettingsChanged($event)"
  [sortField]="sortField"
  [sortDescending]="sortDescending"
  [defaultHiddenColumns]="defaultHiddenColumns"
  [actionColumns]="actionColumns"
  [defaultExportExludedColumns]="defaultExportExludedColumns"
  [availableColumns]="availableColumns"
  (columnOptionsChanged)="handleColumnOptionsChanged($event)"
>
</wm-datatable>

<ng-template #currentActivityTmpl let-row="row" let-value="value">
  <div *ngIf="row.currentActivityDetails">
    <div *ngFor="let v of row.currentActivityDetails; let idx = index">
      <a
        *ngIf="idx < 3"
        [routerLink]="[
          '/application/workflow-application',
          row.appId,
          v.activityDataId
        ]"
      >
        {{ v.activityName }}
      </a>
    </div>
    <a
      [routerLink]=""
      *ngIf="row.currentActivityDetails.length > 3"
      (click)="showCurrentActivities(row)"
      >More...</a
    >
  </div>
</ng-template>

<ng-template #appIdTmpl let-row="row" let-value="value">
  <a
    *ngIf="row.status === ApplicationStatus.InProgress"
    [routerLink]="['/application/workflow-application', row.appId]"
  >
    {{ value }}
  </a>
  <a
    *ngIf="row.status !== ApplicationStatus.InProgress"
    [routerLink]="['/application/workflow-application-summary', row.appId]"
  >
    {{ value }}
  </a>
</ng-template>

<wm-modal-confirm
  moduleId="currentActivitiesConfirm"
  [showButton]="false"
  [title]="
    'Current Activities for Application ' +
    (selectedApplication ? selectedApplication.applicationNumber : '')
  "
  [enabled]="true"
  #currentActivitiesConfirm
>
  <ng-container *ngIf="selectedApplication">
    <div *ngFor="let v of selectedApplication.currentActivityDetails">
      <a
        [routerLink]="[
          '/application/workflow-application',
          selectedApplication.appId,
          v.activityDataId
        ]"
      >
        {{ v.activityName }}
      </a>
    </div>
  </ng-container>
</wm-modal-confirm>

<wm-modal-confirm
  [showButton]="false"
  [title]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  [commandText]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  (accepted)="bulkCloseApplications(selected)"
  [enabled]="true"
  [form]="bulkActionForm"
  #bulkActionConfirm
>
  <div [formGroup]="bulkActionForm">
    <div class="row">
      <div class="col">
        <label for="bulkActionReason">{{ bulkActionText }} Reason</label>
        <textarea
          style="height:100px"
          id="bulkActionReason"
          name="bulkActionReason"
          class="form-control mx-2"
          formControlName="bulkActionReason"
          [placeholder]="bulkActionText + ' Reason'"
          [attr.aria-label]="bulkActionText + ' Reason'"
        >
        </textarea>
        <div *ngIf="bulkActionReason.untouched" class="text-danger">
          * {{ bulkActionText }} Reason is required.
        </div>
        <div
          *ngIf="bulkActionReason.invalid && (bulkActionReason.dirty || bulkActionReason.touched)"
          class="alert alert-danger"
        >
          <div *ngIf="bulkActionReason.errors['required']" class="text-danger">
            * {{ bulkActionText }} Reason is required. *
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="bulkActionDateTime" class="mt-2">
          Time
          <input
            id="bulkActionDateTime"
            name="bulkActionDateTime"
            class="form-control mt-2"
            formControlName="bulkActionDateTime"
            placeholder=""
            aria-label="DateTime"
          />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="mt-2">
          Changed By
          <input
            name="bulkActionUser"
            class="form-control mt-2"
            formControlName="bulkActionUser"
            placeholder=""
            aria-label="BulkActionUser"
          />
        </label>
      </div>
    </div>
  </div>

  <p>
    Any inspections currently in progress in these applications will be marked as Voided, and will not be visible by default in inspection searches.
  </p>
          
  <p>
    Are you sure you want to {{ bulkActionText.toLowerCase() }} <b>{{ selected?.length }} application(s)</b>?
  </p>

</wm-modal-confirm>
